export var HTMLElementAttribute;
(function (HTMLElementAttribute) {
    HTMLElementAttribute["Hidden"] = "hidden";
    HTMLElementAttribute["DataLabel"] = "data-label";
    HTMLElementAttribute["DataIsInvalid"] = "data-is-invalid";
    HTMLElementAttribute["DataUsernameHidden"] = "data-username-hidden";
    HTMLElementAttribute["DataAutofocus"] = "data-autofocus";
    HTMLElementAttribute["Slug"] = "data-slug";
    HTMLElementAttribute["Tooltip"] = "data-tooltip";
    HTMLElementAttribute["Type"] = "type";
    HTMLElementAttribute["Value"] = "value";
})(HTMLElementAttribute || (HTMLElementAttribute = {}));
export var HTMLElementEventType;
(function (HTMLElementEventType) {
    HTMLElementEventType["Blur"] = "blur";
    HTMLElementEventType["Click"] = "click";
    HTMLElementEventType["Input"] = "input";
    HTMLElementEventType["Focus"] = "focus";
    HTMLElementEventType["Paste"] = "paste";
    HTMLElementEventType["Keydown"] = "keydown";
    HTMLElementEventType["Change"] = "change";
    HTMLElementEventType["MouseDown"] = "mousedown";
    HTMLElementEventType["MouseUp"] = "mouseup";
})(HTMLElementEventType || (HTMLElementEventType = {}));
